import { useMemo } from "react"
import {
    ConfigQuery,
    fetchMeetingServiceConfiguration,
    MeetingServiceConfigurationResponse,
} from "../../createOrderApi"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import {
    MeetingServicePriceListState,
    SelectedMainUserState,
    CreateOrderDialogFlow,
    CreateOrderDialogType,
} from "../../createOrderTypes"
import { OrderContextState } from "../../mainForm/helpers"
import { CreateOrderType } from "../../helpers"
import { LoadingSpinner } from "../../../loading/LoadingSpinner"
import { MeetingServiceForm } from "./MeetingServiceForm"
import { MeetingServiceOrder } from "../../../../../modules/merchant/accounting/accounting/accountingTypes"
import { DynamicConfigKey, DynamicMainFormValues, MainOrderFormikRef, MeetingServiceTabValues } from "../form/formTypes"
import { ensurePaymentMethod, findGroupByFieldKey } from "../form/helpers"
import { useFormikContext } from "formik"

export const selectMeetingServiceConfig = (data: MeetingServiceConfigurationResponse) => {
    if (data?.meetingServiceConfig) {
        const { meetingServiceConfig } = data
        if (
            findGroupByFieldKey(meetingServiceConfig.sections, DynamicConfigKey.PAYMENT_METHOD)?.fields.find(
                (el) => el.key === DynamicConfigKey.PAYMENT_METHOD,
            )?.active
        ) {
            return meetingServiceConfig
        } else {
            return ensurePaymentMethod(meetingServiceConfig)
        }
    } else return undefined
}

type MeetingServiceFormContainerProps = Readonly<{
    user: SelectedMainUserState
    handleClose: () => void
    dialogType: CreateOrderDialogType
    handleOpenSelectPriceListsDialog: () => void
    flowConfig?: CreateOrderDialogFlow
    isDrawerOpen: boolean
    orderType: CreateOrderType
    orderDetails?: MeetingServiceOrder
    orderContext: OrderContextState
    handleSubmitMeetingService: (values: MeetingServiceTabValues) => void
    outerFormik: MainOrderFormikRef
}>

export function MeetingServiceFormContainer({
    user,
    handleClose,
    dialogType,
    handleOpenSelectPriceListsDialog,
    flowConfig,
    isDrawerOpen,
    orderType,
    orderDetails,
    orderContext,
    handleSubmitMeetingService,
    outerFormik,
}: MeetingServiceFormContainerProps) {
    const { values } = useFormikContext<DynamicMainFormValues>()
    const priceList: MeetingServicePriceListState = values["priceList"]

    const merchantId = priceList.item?.merchantId || 0
    const configQueryDeps = useMemo(() => {
        return { userId: user.userId, merchantId }
    }, [user.userId, merchantId])

    const { data: meetingServiceConfiguration, isLoading } = useApiQuery(fetchMeetingServiceConfiguration, {
        queryName: ConfigQuery.MEETING_SERVICE_CONFIG,
        dependencies: configQueryDeps,
        enabled: !!merchantId,
        select: selectMeetingServiceConfig,
        useErrorBoundary: true,
    })

    if (isLoading || !outerFormik.current) {
        return <LoadingSpinner />
    }

    return (
        <MeetingServiceForm
            user={user}
            handleClose={handleClose}
            dialogType={dialogType}
            handleOpenSelectPriceListsDialog={handleOpenSelectPriceListsDialog}
            flowConfig={flowConfig}
            isDrawerOpen={isDrawerOpen}
            orderType={orderType}
            meetingServiceConfiguration={meetingServiceConfiguration}
            orderDetails={orderDetails}
            mainValues={values}
            orderContext={orderContext}
            handleSubmitMeetingService={handleSubmitMeetingService}
            outerFormik={outerFormik}
        />
    )
}
